import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, OnInit } from '@angular/core';
import { RequestRoot } from 'types';
import { AppContext } from '../control/context';
import { ValidationService } from '../validation/validation.service';

@Component({
  selector: 'i-field-b',
  templateUrl: './fieldB.component.html',
  styleUrls: ['./fieldB.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldBComponent implements OnInit {
  @Input() model: RequestRoot;
  @Input() i18n_name: string;
  @Output() click = new EventEmitter<void>();

  _i18n_name: string;

  constructor(private appContext: AppContext, private validationService: ValidationService) {}

  ngOnInit() {
    this._i18n_name = this.appContext.getI18NString(this.i18n_name);
  }

  _click() {
    this.click.emit();
    this.validationService.validate();
    this.appContext.storeDraft(this.model);
  }
}
